import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isMobileMenuOpen: false,
  openInFiltersMode: false,
};

const mobileMenuSlice = createSlice({
  name: 'mobileMenu',
  initialState,
  reducers: {
    setMobileMenuOpen: (state, action) => {
      state.isMobileMenuOpen = action.payload;
      // При закрытии сбрасываем режим фильтров
      if (!action.payload) {
        state.openInFiltersMode = false;
      }
    },
    toggleMobileMenu: (state) => {
      state.isMobileMenuOpen = !state.isMobileMenuOpen;
      // При закрытии сбрасываем режим фильтров
      if (!state.isMobileMenuOpen) {
        state.openInFiltersMode = false;
      }
    },
    setOpenInFiltersMode: (state, action) => {
      state.openInFiltersMode = action.payload;
    },
    openMobileMenuInFiltersMode: (state) => {
      state.isMobileMenuOpen = true;
      state.openInFiltersMode = true;
    },
  },
});

export const {
  setMobileMenuOpen,
  toggleMobileMenu,
  setOpenInFiltersMode,
  openMobileMenuInFiltersMode,
} = mobileMenuSlice.actions;
export default mobileMenuSlice.reducer;
